<div class="row page-header">
    <div class="col-12">
        <h1>Bid Dashboard <small>Overview of current bids combined with WIP</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        @if (chartData) {
            <div class="col-6">
                <wj-flex-chart
                    style="height: 450px"
                    [itemsSource]="chartData.points"
                    [bindingX]="'label'"
                    [chartType]="chartData.chartType"
                    [header]="chartData.title"
                    [legendToggle]="true"
                >
                    <wj-flex-chart-legend [position]="'Bottom'"></wj-flex-chart-legend>
                    <wj-flex-chart-axis [wjProperty]="'axisY'" [title]="'Revenue'" [format]="'C0'" [min]="0"></wj-flex-chart-axis>
                    @for (serie of chartData.series; track serie) {
                        <wj-flex-chart-series [binding]="serie.binding" [name]="serie.name"> </wj-flex-chart-series>
                    }
                </wj-flex-chart>
            </div>
        }
        @if (chartData2) {
            <div class="col-6">
                <wj-flex-chart
                    style="height: 450px"
                    [itemsSource]="chartData2.points"
                    [bindingX]="'label'"
                    [chartType]="chartData2.chartType"
                    [header]="chartData2.title"
                    [stacking]="chartData2.stacking"
                    [legendToggle]="true"
                >
                    <wj-flex-chart-legend [position]="'Bottom'"></wj-flex-chart-legend>
                    <wj-flex-chart-axis
                        [wjProperty]="'axisY'"
                        [title]="'Mid Contract Range'"
                        [format]="'C0'"
                        [min]="0"
                    ></wj-flex-chart-axis>
                    @for (serie of chartData2.series; track serie) {
                        <wj-flex-chart-series [binding]="serie.binding" [name]="serie.name"> </wj-flex-chart-series>
                    }
                </wj-flex-chart>
            </div>
        }
    </div>
    <div class="row">
        <div class="col-6">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title" style="text-align: center; color: #353535">Bid Metrics</h5>
                    <table class="table table-sm table-borderless mb-0">
                        <tbody>
                            <tr>
                                <td class="text-end" style="padding-right: 8px">Bids Won This Quarter:</td>
                                <td class="text-start">
                                    <strong>{{ metrics.bidsWonThisQuarter }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-end" style="padding-right: 8px">Bids Won Last Quarter:</td>
                                <td class="text-start">
                                    <strong>{{ metrics.bidsWonLastQuarter }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-end" style="padding-right: 8px">Bids Won Past 12 Months:</td>
                                <td class="text-start">
                                    <strong>{{ metrics.bidsWonRolling12Months }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-end" style="padding-right: 8px; padding-top: 12px">Current Quarter Goal:</td>
                                <td class="text-start" style="padding-top: 12px">
                                    @if (editingCurrentQuarterGoal) {
                                        <div style="display: flex; align-items: center; gap: 4px">
                                            <input
                                                #currentQuarterGoalInput
                                                type="text"
                                                [(ngModel)]="currentQuarterGoalEditValue"
                                                class="form-control form-control-sm"
                                                style="flex: 1"
                                                (keyup.enter)="saveCurrentQuarterGoal()"
                                                (keyup.escape)="cancelEditCurrentQuarterGoal()"
                                            />
                                            <fa-icon
                                                [icon]="faCheck"
                                                class="text-success"
                                                style="cursor: pointer"
                                                (click)="saveCurrentQuarterGoal()"
                                                title="Save"
                                            ></fa-icon>
                                        </div>
                                    } @else {
                                        <div style="display: flex; align-items: center; gap: 4px">
                                            <strong>{{ metrics.currentQuarterGoal }}</strong>
                                            <fa-icon
                                                [icon]="faEdit"
                                                class="text-muted"
                                                style="cursor: pointer"
                                                (click)="startEditCurrentQuarterGoal()"
                                                title="Edit"
                                            ></fa-icon>
                                        </div>
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td class="text-end" style="padding-right: 8px; padding-top: 12px">
                                    Remaining {{ metrics.currentYear }} Revenue Goal:
                                </td>
                                <td class="text-start" style="padding-top: 12px">
                                    @if (editingCurrentYearRevenueGoal) {
                                        <div style="display: flex; align-items: center; gap: 4px">
                                            <input
                                                #currentYearRevenueGoalInput
                                                type="text"
                                                [(ngModel)]="currentYearRevenueGoalEditValue"
                                                class="form-control form-control-sm"
                                                style="flex: 1"
                                                (keyup.enter)="saveCurrentYearRevenueGoal()"
                                                (keyup.escape)="cancelEditCurrentYearRevenueGoal()"
                                            />
                                            <fa-icon
                                                [icon]="faCheck"
                                                class="text-success"
                                                style="cursor: pointer"
                                                (click)="saveCurrentYearRevenueGoal()"
                                                title="Save"
                                            ></fa-icon>
                                        </div>
                                    } @else {
                                        <div style="display: flex; align-items: center; gap: 4px">
                                            <strong>{{ metrics.currentYearRevenueGoal }}</strong>
                                            <fa-icon
                                                [icon]="faEdit"
                                                class="text-muted"
                                                style="cursor: pointer"
                                                (click)="startEditCurrentYearRevenueGoal()"
                                                title="Edit"
                                            ></fa-icon>
                                        </div>
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td class="text-end" style="padding-right: 8px">Remaining {{ metrics.currentYear }} Backlog:</td>
                                <td class="text-start">
                                    <strong>{{ metrics.currentYearRevenueBacklog }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-end" style="padding-right: 8px; padding-top: 12px">{{ metrics.nextYear }} Revenue Goal:</td>
                                <td class="text-start" style="padding-top: 12px">
                                    @if (editingNextYearRevenueGoal) {
                                        <div style="display: flex; align-items: center; gap: 4px">
                                            <input
                                                #nextYearRevenueGoalInput
                                                type="text"
                                                [(ngModel)]="nextYearRevenueGoalEditValue"
                                                class="form-control form-control-sm"
                                                style="flex: 1"
                                                (keyup.enter)="saveNextYearRevenueGoal()"
                                                (keyup.escape)="cancelEditNextYearRevenueGoal()"
                                            />
                                            <fa-icon
                                                [icon]="faCheck"
                                                class="text-success"
                                                style="cursor: pointer"
                                                (click)="saveNextYearRevenueGoal()"
                                                title="Save"
                                            ></fa-icon>
                                        </div>
                                    } @else {
                                        <div style="display: flex; align-items: center; gap: 4px">
                                            <strong>{{ metrics.nextYearRevenueGoal }}</strong>
                                            <fa-icon
                                                [icon]="faEdit"
                                                class="text-muted"
                                                style="cursor: pointer"
                                                (click)="startEditNextYearRevenueGoal()"
                                                title="Edit"
                                            ></fa-icon>
                                        </div>
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td class="text-end" style="padding-right: 8px">{{ metrics.nextYearBacklogYear }} Revenue Backlog:</td>
                                <td class="text-start">
                                    <strong>{{ metrics.nextYearRevenueBacklog }}</strong>
                                </td>
                            </tr>
                            <tr>
                                <td class="text-end" style="padding-right: 8px; padding-top: 12px">
                                    {{ metrics.followingYear }}+ Revenue Goal:
                                </td>
                                <td class="text-start" style="padding-top: 12px">
                                    @if (editingFollowingYearRevenueGoal) {
                                        <div style="display: flex; align-items: center; gap: 4px">
                                            <input
                                                #followingYearRevenueGoalInput
                                                type="text"
                                                [(ngModel)]="followingYearRevenueGoalEditValue"
                                                class="form-control form-control-sm"
                                                style="flex: 1"
                                                (keyup.enter)="saveFollowingYearRevenueGoal()"
                                                (keyup.escape)="cancelEditFollowingYearRevenueGoal()"
                                            />
                                            <fa-icon
                                                [icon]="faCheck"
                                                class="text-success"
                                                style="cursor: pointer"
                                                (click)="saveFollowingYearRevenueGoal()"
                                                title="Save"
                                            ></fa-icon>
                                        </div>
                                    } @else {
                                        <div style="display: flex; align-items: center; gap: 4px">
                                            <strong>{{ metrics.followingYearRevenueGoal }}</strong>
                                            <fa-icon
                                                [icon]="faEdit"
                                                class="text-muted"
                                                style="cursor: pointer"
                                                (click)="startEditFollowingYearRevenueGoal()"
                                                title="Edit"
                                            ></fa-icon>
                                        </div>
                                    }
                                </td>
                            </tr>
                            <tr>
                                <td class="text-end" style="padding-right: 8px">
                                    {{ metrics.followingYearBacklogYear }}+ Revenue Backlog:
                                </td>
                                <td class="text-start">
                                    <strong>{{ metrics.followingYearRevenueBacklog }}</strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
